import { combineReducers } from "redux";
import auth from "./AuthReducers";
import profile from "./ProfileReducers";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import friends from "./FriendsReducers";
import usernames from "./UserNameReducers";
import expansion from "./ExpansionsReducers";
import game from "./GameReducers";

export default combineReducers({
  auth: auth,
  profile: profile,
  friends: friends,
  usernames: usernames,
  expansion: expansion,
  game: game
});
